












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { TopDataItem } from "@/classes/DistroDataSet";

/* eslint-disable @typescript-eslint/camelcase */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
/* eslint-enable @typescript-eslint/camelcase */

am4core.useTheme(am4themes_material);
// am4core.useTheme(am4themes_animated);

@Component
export default class TotalsChart extends Vue {
  @Prop() chartData!: TopDataItem[];
  @Prop() public datesFilter!: Date[];
  @Prop() count!: number;

  get actualCount(): number {
    return Math.min(this.$props.count, this.$props.chartData.length);
  }

  chart?: am4charts.XYChart;

  mounted() {
    this.renderChart();
  }

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  @Watch("chartData")
  renderChart() {
    if (this.chart) {
      this.chart.dispose();
    }
    this.chart = am4core.create(
      this.$refs.topCompareChart as HTMLDivElement,
      am4charts.XYChart
    );

    this.chart.data = this.$props.chartData;

    const xAxes1 = this.chart.xAxes.push(new am4charts.DateAxis());
    xAxes1.dataFields.date = "month";
    xAxes1.cursorTooltipEnabled = true;

    if (this.$props.datesFilter && this.$props.datesFilter.length > 1) {
      xAxes1.min = new Date(this.$props.datesFilter[0]).getTime();
      xAxes1.max = new Date(this.$props.datesFilter[1]).getTime();
    }

    xAxes1.baseInterval = { timeUnit: "month", count: 1 };
    xAxes1.periodChangeDateFormats.setKey("day", "MMM");
    xAxes1.dateFormats.setKey("day", "MMM");

    xAxes1.renderer.grid.template.location = 0;

    xAxes1.renderer.minGridDistance = 50;

    const axis1 = this.chart.yAxes.push(new am4charts.ValueAxis());
    axis1.id = "axis1";
    axis1.title.text = "Earnings (USD)";
    axis1.min = 0;
    axis1.cursorTooltipEnabled = false;

    axis1.renderer.maxLabelPosition = 0.98;

    axis1.numberFormatter = new am4core.NumberFormatter();
    axis1.numberFormatter.numberFormat = "$0.###";

    for (let itemNo = 0; itemNo < this.actualCount; itemNo++) {
      const series2 = this.chart.series.push(new am4charts.LineSeries());
      series2.name = this.$props.chartData[itemNo].name;
      series2.data = this.$props.chartData[itemNo].monthlyTotals;
      series2.tooltipHTML = "<b>{name}</b><br />${valueY.formatNumber('0.00')}";

      series2.bullets.push(new am4charts.CircleBullet());
      series2.minBulletDistance = 50;

      series2.dataFields.valueY = "earningsUSD";
      series2.dataFields.dateX = "month";

      series2.strokeWidth = 3;

      series2.sequencedInterpolation = true;
      series2.sequencedInterpolationDelay = 100;
    }

    this.chart.legend = new am4charts.Legend();

    // Cursor
    this.chart.cursor = new am4charts.XYCursor();
    this.chart.cursor.behavior = "zoomX";
    // this.chart.cursor.lineX.strokeOpacity = 0;
    this.chart.cursor.lineY.strokeOpacity = 0;
  }
}
